import axios from 'axios'
import { stringify } from 'qs'
import store from '@/store'
import { notification, message } from 'ant-design-vue'

const env = process.env.NODE_ENV

const codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。'
}

// 创建 axios 实例
let instance = axios.create({
  timeout: 60000
})

// 设置post默认 Content-Type
instance.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'
// instance.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
instance.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'

let pending = []

let removePending = (config) => {
  for (let p in pending) {
    if (pending[p].url === `${config.url}?${stringify(config.data)}`) {
      pending[p].cancel('cancelToken')
      pending.splice(p, 1)
    }
  }
}

// 添加请求拦截器
instance.interceptors.request.use(
  config => {
    removePending(config)
    store.commit('setSpinning', true)
    config.cancelToken = new axios.CancelToken((cancel) => {
      pending.push({
        url: `${config.url}?${stringify(config.data)}`,
        cancel: cancel
      })
    })
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    } else if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded;charset=utf-8') {
      config.data = stringify(config.data)
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 添加响应拦截器
instance.interceptors.response.use(
  response => {
    store.commit('setSpinning', false)
    let { data } = response
    if (data.session === 'invalid') {
      window.location.href = data.url
      return false
    }
    if (!data.flag) {
      if (env === 'development') {
        // notification.error({
        //   message: `请求失败 ${response.config.url}:\n${response.config.data}`,
        //   description: data.msg
        // })
      }
      // if (data.code === -12) {
      //   window.location.href = '#/login'
      // } else {
      message.error(data.msg || data.mes || data.code || data.result || '操作失败')
      // }
      return Promise.reject(data)
    }
    // 处理后台返回列表为空
    if (data.data && 'total' in data.data && !data.data.list) {
      data.data.list = []
    }
    return data
  },
  error => {
    store.commit('setSpinning', false)
    // 重复请求被自动取消时，静默处理，避免弹出 "cancelToken" 提示
    if (axios.isCancel(error)) {
      return Promise.reject(error)
    }
    if (!error.response) {
      // 网络错误、超时等情况
      message.error(error.message || '网络请求失败，请稍后重试')
      return Promise.reject(error)
    }
    let { status, statusText } = error.response
    let url = error.request.responseURL
    if (url.indexOf('getXmAndSjh') > -1 && status === 404) {
      return false
    }
    let errortext = codeMessage[status] || statusText
    if (env === 'development') {
      notification.error({
        message: `请求错误 ${status}: ${url}`,
        description: errortext
      })
    }
    message.error(errortext || '请求失败')
    return Promise.reject(error)
  }
)

export default {
  post (url, params, config) {
    // 去除首尾空格
    // for (var key in params) {
    //   if (params[key] && typeof (params[key]) === 'string') {
    //     params[key] = params[key].replace(/(^\s*)|(\s*$)/g, '')
    //   }
    // }
    if (env === 'production') {
      url = url.replace('/api', '')
    }
    // if (env === 'development') {
    //   url = url.replace('/api', '')
    // }
    return instance.post(url, params, config)
  },
  mock (url, params) {
    return axios.get(url, params).then(response => response.data)
  },
  get (url, params, config) {
    if (env === 'production') {
      url = url.replace('/api', '')
    }
    return instance.get(url, params, config)
  }
}
